"use client";

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import type { IPaginatedResult } from "@/lib/shared/types/pagination";
import { giftSetGridKeys } from "../../shared/gridKeys";
import type { GiftSet } from "../../shared/types";

interface UseGiftSetsGridQueryParams {
  page?: number;
  enabled?: boolean;
  initialData?: IPaginatedResult<GiftSet>;
}

export function useGiftSetsGridQuery({
  page = 1,
  enabled = true,
  initialData,
}: UseGiftSetsGridQueryParams) {
  const locale = useLocale();

  return useQuery<IPaginatedResult<GiftSet>>({
    queryKey: giftSetGridKeys.list(locale, page),
    queryFn: () => {
      const params = new URLSearchParams({
        locale,
        page: page.toString(),
      });
      const url = `/${locale}/api/gift-sets?${params.toString()}`;
      return fetcher(url);
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    initialData: initialData && page === 1 ? initialData : undefined,
  });
}
